module.exports = __webpack_public_path__ + "static/media/B26A9857-min.709bfc24.jpg";